// extracted by mini-css-extract-plugin
export var hero = "Hero--hero--wO6Nk";
export var overlay = "Hero--overlay--gzolU";
export var tkMyriadProSemiCondensed = "Hero--tk-myriad-pro-semi-condensed--76Ojw";